// Pro plan price IDs
export const PRO_PLAN_PRICE_IDS = [
  'price_1QiFoKL6hyI2wddeDrG84QMO',
  'price_1QtUk0L6hyI2wddeQJ9XjdRl',
  'price_1QtUjgL6hyI2wdde1QqUJoG1',
  'price_1N2zDbL6hyI2wddeW4ebJgeu',
  'price_1Mw8aQL6hyI2wddeprlHTFMX',
  'price_1QiFoCL6hyI2wddetuUDAA8b' // Test price ID
];

// Helper function to check if a price ID belongs to a pro plan
export const isProPlan = (priceId) => PRO_PLAN_PRICE_IDS.includes(priceId); 